const appTranslations = {
  fi: {
    app: {
      platformTitle: 'Lautapeliliigan hallinta-alusta',
      loading: 'Ladataan...',
      saveError: 'Virhe tallennuksessa',
      impersonationFailed: 'Klubiin kirjautuminen epäonnistui: {error}',
      impersonationFailedGeneric: 'Klubiin kirjautuminen epäonnistui'
    },
    magicLink: {
      loginFailed: 'Kirjautuminen epäonnistui',
      invalidOrExpiredLink: 'Virheellinen tai vanhentunut linkki',
      tooManyAttempts: 'Liian monta kirjautumisyritystä. Odota hetki ja kokeile uudelleen.',
      invalidOrExpiredLinkTitle: 'Virheellinen tai vanhentunut linkki!',
      close: 'Sulje',
      loggingIn: 'Kirjaudutaan...'
    },
    season: {
      season: 'Kausi',
      seasonPossessive: 'Kauden',
      seasonDash: 'Kausi —',
      historical: 'Historiallinen',
      otherSeasons: 'Muut kaudet',
      selectSeason: 'Valitse kausi',
      current: 'Nykyinen',
      proRequired: 'Pro-taso vaaditaan',
      archivedProOnly: 'Vanhat kaudet ovat Pro-tason ominaisuus.',
      comparePlans: 'Katso tasot',
      games: 'pelit'
    },
    dashboard: {
      video: 'Video',
      hideVideo: 'Piilota',
      hideVideoAria: 'Piilota video',
      aiGeneratedWatermark: 'Tuotettu tekoälyllä',
      letsPlay: "Let's Play!",
      noWinner: 'Ei voittajaa',
      upcomingEvents: 'Tulevat peli-illat',
      showAll: 'Näytä kaikki →',
      voting: 'Äänestys ({count} aikaa)',
      leaderboard: 'Leaderboard',
      leaderboardForecast: 'Leaderboard (Ennuste)',
      analyzing: 'Analysoidaan...',
      returnToReality: 'Palaa todellisuuteen',
      showFuture: 'Näytä tulevaisuus',
      futureHiddenPointsHint:
        'Menestyspisteet-sarake on piilotettu; ennuste näkyy Pelit- ja Ø MP -sarakkeissa sekä rivin laajennuksessa',
      sortTitle: 'Järjestä: laskeva → nouseva → oletus',
      defaultSortTitle: 'Oletusjärjestys',
      rank: 'Sija',
      name: 'Nimi',
      avgPointsPerGame: 'Ø MP / peli',
      avgPointsPerGameForecast: 'Ø MP / peli *',
      avgPointsForecastTitle: 'Menestyspisteet / peli (mukana ennustetut pelit)',
      games: 'Pelit',
      gamesForecastTitle: 'Pelatut + ennustetut pelit',
      time: 'Aika',
      points: 'Menestyspisteet',
      pointsShort: 'MP',
      forecast: 'Ennuste',
      winRate: 'Voitto-%',
      predictedGames: 'Ennustetut pelit',
      game: 'Peli',
      players: 'Pelaajat',
      futureSummary: 'Yhteensä: +{points} MP ({wins} voittoa, {games} peliä)',
      playedGames: 'Pelatut pelit',
      loadingSmall: 'Ladataan...',
      noSessions: 'Ei pelejä tällä kaudella',
      sessionRank: 'Sija',
      sessionVp: 'VP',
      sessionDuration: 'Kesto',
      sessionAlt: 'Pelisessio'
    },
    landing: {
      codePlaceholder: '000000',
      verify: 'Vahvista',
      existingAccountRegistered: 'Osoite {email} on jo rekisteröity',
      existingAccountWithClub: ' (klubi: {clubName})',
      existingAccountQuestion:
        'Haluatko vahvistaa tilin uudelleen ja saada uuden magic linkin?',
      confirmAccount: 'Kyllä, vahvista tili',
      useDifferentEmail: 'Käytä toista osoitetta',
      checkEmailRelogin: 'Tarkista sähköpostisi! Syötä koodi saadaksesi uuden magic linkin.',
      checkEmailCode: 'Tarkista sähköpostisi! Syötä 6-numeroinen vahvistuskoodi.',
      resendCode: 'Lähetä koodi uudelleen',
      cancel: 'Peruuta',
      devCodeHint: 'Kehityskoodi: {code}',
      magicLinkSent: 'Magic link lähetetty sähköpostiisi. Avaa linkki kirjautuaksesi.',
      magicLinkFailed:
        'Vahvistus onnistui, mutta magic linkin lähetys epäonnistui. Yritä hetken kuluttua uudelleen.',
      backToStart: 'Palaa alkuun',
      invalidCode: 'Anna 6-numeroinen vahvistuskoodi',
      verificationFailed: 'Vahvistus epäonnistui',
      codeSendFailed: 'Koodin lähetys epäonnistui.',
      codeResendFailed: 'Koodin uudelleenlähetys epäonnistui.',
      footerBrand: 'Board Game League',
      footerCompany: 'Proseduuri Oy',
      languageLabel: 'Kieli'
    },
    onboarding: {
      welcome: 'Tervetuloa!',
      welcomeSubtitle: 'Luodaan sinulle oma lautapeliklubi',
      stepClub: 'Klubin tiedot',
      stepAdmin: 'Admin-tili',
      stepSettings: 'Asetukset',
      clubCreated: 'Klubi luotu',
      welcomeEmailFailed:
        'Klubisi on valmis, mutta tervetuloviestin lähetys epäonnistui. Pyydä magic link adminilta tai yritä uudelleen.',
      welcomeEmailSent:
        'Klubisi on valmis. Tarkista sähköpostisi — lähetimme magic linkin kirjautumiseen.',
      backToHome: 'Palaa etusivulle',
      clubDetailsTitle: 'Klubin tiedot',
      clubDetailsDescription: 'Kerro meille lautapeliklubistasi',
      clubNameLabel: 'Klubin nimi *',
      clubNamePlaceholder: 'esim. Turun Noppanikkari',
      clubSlugLabel: 'URL-osoite *',
      clubSlugPlaceholder: 'turun-noppanikkari',
      clubDescriptionLabel: 'Kuvaus (valinnainen)',
      clubDescriptionPlaceholder: 'Lyhyt kuvaus klubistanne...',
      adminTitle: 'Admin-tilisi',
      adminDescription: 'Sinusta tulee klubin ensimmäinen admin',
      adminNameLabel: 'Nimesi *',
      adminNamePlaceholder: 'Miten muut pelaajat tunnistavat sinut?',
      emailLabel: 'Sähköposti',
      magicLinkInfo: 'Kirjaudut aina magic link -linkillä. Ei salasanoja muistettavaksi!',
      settingsTitle: 'Alkuasetukset',
      settingsDescription: 'Voit muuttaa näitä myöhemmin asetuksista',
      languageLabel: 'Kieli',
      timezoneLabel: 'Aikavyöhyke',
      timezoneHelsinki: 'Helsinki (UTC+2/+3)',
      timezoneStockholm: 'Tukholma (UTC+1/+2)',
      timezoneLondon: 'Lontoo (UTC+0/+1)',
      summaryTitle: 'Yhteenveto',
      summaryClub: 'Klubi:',
      summaryUrl: 'URL:',
      summaryAdmin: 'Admin:',
      errorClubName: 'Anna klubille nimi',
      errorClubSlug: 'Anna klubille URL-osoite',
      errorAdminName: 'Anna nimesi',
      back: 'Takaisin',
      next: 'Seuraava',
      createClub: 'Luo klubi',
      languageFi: 'Suomi',
      languageEn: 'English',
      languageSv: 'Svenska'
    }
  },
  en: {
    app: {
      platformTitle: 'Board game league management platform',
      loading: 'Loading...',
      saveError: 'Error saving',
      impersonationFailed: 'Failed to sign in to club: {error}',
      impersonationFailedGeneric: 'Failed to sign in to club'
    },
    magicLink: {
      loginFailed: 'Login failed',
      invalidOrExpiredLink: 'Invalid or expired link',
      tooManyAttempts: 'Too many login attempts. Please wait a moment and try again.',
      invalidOrExpiredLinkTitle: 'Invalid or expired link!',
      close: 'Close',
      loggingIn: 'Signing in...'
    },
    season: {
      season: 'Season',
      seasonPossessive: 'Season',
      seasonDash: 'Season —',
      historical: 'Historical',
      otherSeasons: 'Other seasons',
      selectSeason: 'Select season',
      current: 'Current',
      proRequired: 'Pro plan required',
      archivedProOnly: 'Archived seasons are available on the Pro plan.',
      comparePlans: 'Compare plans',
      games: 'games'
    },
    dashboard: {
      video: 'Video',
      hideVideo: 'Hide',
      hideVideoAria: 'Hide video',
      aiGeneratedWatermark: 'Generated by AI',
      letsPlay: "Let's Play!",
      noWinner: 'No winner',
      upcomingEvents: 'Upcoming game nights',
      showAll: 'View all →',
      voting: 'Voting ({count} slots)',
      leaderboard: 'Leaderboard',
      leaderboardForecast: 'Leaderboard (Forecast)',
      analyzing: 'Analysing...',
      returnToReality: 'Back to reality',
      showFuture: 'Show the future',
      futureHiddenPointsHint:
        'League points column is hidden; forecast appears in Games, Avg LP and row expansion',
      sortTitle: 'Sort: descending → ascending → default',
      defaultSortTitle: 'Default sort',
      rank: 'Rank',
      name: 'Name',
      avgPointsPerGame: 'Avg LP / game',
      avgPointsPerGameForecast: 'Avg LP / game *',
      avgPointsForecastTitle: 'League points per game (includes predicted games)',
      games: 'Games',
      gamesForecastTitle: 'Played + predicted games',
      time: 'Time',
      points: 'League points',
      pointsShort: 'LP',
      forecast: 'Forecast',
      winRate: 'Win %',
      predictedGames: 'Predicted games',
      game: 'Game',
      players: 'Players',
      futureSummary: 'Total: +{points} LP ({wins} wins, {games} games)',
      playedGames: 'Played games',
      loadingSmall: 'Loading...',
      noSessions: 'No games this season',
      sessionRank: 'Rank',
      sessionVp: 'VP',
      sessionDuration: 'Duration',
      sessionAlt: 'Game session'
    },
    landing: {
      codePlaceholder: '000000',
      verify: 'Verify',
      existingAccountRegistered: 'Address {email} is already registered',
      existingAccountWithClub: ' (club: {clubName})',
      existingAccountQuestion:
        'Would you like to verify your account again and receive a new magic link?',
      confirmAccount: 'Yes, verify account',
      useDifferentEmail: 'Use a different address',
      checkEmailRelogin: 'Check your email! Enter the code to receive a new magic link.',
      checkEmailCode: 'Check your email! Enter the 6-digit verification code.',
      resendCode: 'Resend code',
      cancel: 'Cancel',
      devCodeHint: 'Development code: {code}',
      magicLinkSent: 'Magic link sent to your email. Open the link to sign in.',
      magicLinkFailed:
        'Verification succeeded, but sending the magic link failed. Please try again shortly.',
      backToStart: 'Back to start',
      invalidCode: 'Enter a 6-digit verification code',
      verificationFailed: 'Verification failed',
      codeSendFailed: 'Failed to send code.',
      codeResendFailed: 'Failed to resend code.',
      footerBrand: 'Board Game League',
      footerCompany: 'Proseduuri Oy',
      languageLabel: 'Language'
    },
    onboarding: {
      welcome: 'Welcome!',
      welcomeSubtitle: "Let's create your own board game club",
      stepClub: 'Club details',
      stepAdmin: 'Admin account',
      stepSettings: 'Settings',
      clubCreated: 'Club created',
      welcomeEmailFailed:
        'Your club is ready, but the welcome email could not be sent. Ask an admin for a magic link or try again.',
      welcomeEmailSent:
        'Your club is ready. Check your email — we sent a magic link to sign in.',
      backToHome: 'Back to home',
      clubDetailsTitle: 'Club details',
      clubDetailsDescription: 'Tell us about your board game club',
      clubNameLabel: 'Club name *',
      clubNamePlaceholder: 'e.g. Downtown Dice Club',
      clubSlugLabel: 'URL address *',
      clubSlugPlaceholder: 'downtown-dice-club',
      clubDescriptionLabel: 'Description (optional)',
      clubDescriptionPlaceholder: 'A short description of your club...',
      adminTitle: 'Your admin account',
      adminDescription: 'You will be the first admin of the club',
      adminNameLabel: 'Your name *',
      adminNamePlaceholder: 'How do other players know you?',
      emailLabel: 'Email',
      magicLinkInfo: 'You always sign in with a magic link. No passwords to remember!',
      settingsTitle: 'Initial settings',
      settingsDescription: 'You can change these later in settings',
      languageLabel: 'Language',
      timezoneLabel: 'Time zone',
      timezoneHelsinki: 'Helsinki (UTC+2/+3)',
      timezoneStockholm: 'Stockholm (UTC+1/+2)',
      timezoneLondon: 'London (UTC+0/+1)',
      summaryTitle: 'Summary',
      summaryClub: 'Club:',
      summaryUrl: 'URL:',
      summaryAdmin: 'Admin:',
      errorClubName: 'Enter a club name',
      errorClubSlug: 'Enter a URL for the club',
      errorAdminName: 'Enter your name',
      back: 'Back',
      next: 'Next',
      createClub: 'Create club',
      languageFi: 'Suomi',
      languageEn: 'English',
      languageSv: 'Svenska'
    }
  },
  sv: {
    app: {
      platformTitle: 'Plattform för brädspelsligahantering',
      loading: 'Laddar...',
      saveError: 'Fel vid sparning',
      impersonationFailed: 'Det gick inte att logga in i klubben: {error}',
      impersonationFailedGeneric: 'Det gick inte att logga in i klubben'
    },
    magicLink: {
      loginFailed: 'Inloggningen misslyckades',
      invalidOrExpiredLink: 'Ogiltig eller utgången länk',
      tooManyAttempts: 'För många inloggningsförsök. Vänta en stund och försök igen.',
      invalidOrExpiredLinkTitle: 'Ogiltig eller utgången länk!',
      close: 'Stäng',
      loggingIn: 'Loggar in...'
    },
    season: {
      season: 'Säsong',
      seasonPossessive: 'Säsongens',
      seasonDash: 'Säsong —',
      historical: 'Historisk',
      otherSeasons: 'Andra säsonger',
      selectSeason: 'Välj säsong',
      current: 'Aktuell',
      proRequired: 'Pro-nivå krävs',
      archivedProOnly: 'Arkiverade säsonger är tillgängliga med Pro.',
      comparePlans: 'Jämför nivåer',
      games: 'spel'
    },
    dashboard: {
      video: 'Video',
      hideVideo: 'Dölj',
      hideVideoAria: 'Dölj video',
      aiGeneratedWatermark: 'Skapad med AI',
      letsPlay: "Let's Play!",
      noWinner: 'Ingen vinnare',
      upcomingEvents: 'Kommande spelkvällar',
      showAll: 'Visa alla →',
      voting: 'Omröstning ({count} tider)',
      leaderboard: 'Topplista',
      leaderboardForecast: 'Topplista (prognos)',
      analyzing: 'Analyserar...',
      returnToReality: 'Tillbaka till verkligheten',
      showFuture: 'Visa framtiden',
      futureHiddenPointsHint:
        'Ligapoängkolumnen är dold; prognosen visas i Spel, Snitt LP och radexpansion',
      sortTitle: 'Sortera: fallande → stigande → standard',
      defaultSortTitle: 'Standardsortering',
      rank: 'Plats',
      name: 'Namn',
      avgPointsPerGame: 'Snitt LP / spel',
      avgPointsPerGameForecast: 'Snitt LP / spel *',
      avgPointsForecastTitle: 'Ligapoäng per spel (inkl. prognostiserade spel)',
      games: 'Spel',
      gamesForecastTitle: 'Spelade + prognostiserade spel',
      time: 'Tid',
      points: 'Ligapoäng',
      pointsShort: 'LP',
      forecast: 'Prognos',
      winRate: 'Vinst-%',
      predictedGames: 'Prognostiserade spel',
      game: 'Spel',
      players: 'Spelare',
      futureSummary: 'Totalt: +{points} LP ({wins} vinster, {games} spel)',
      playedGames: 'Spelade spel',
      loadingSmall: 'Laddar...',
      noSessions: 'Inga spel denna säsong',
      sessionRank: 'Plats',
      sessionVp: 'VP',
      sessionDuration: 'Längd',
      sessionAlt: 'Spelsession'
    },
    landing: {
      codePlaceholder: '000000',
      verify: 'Verifiera',
      existingAccountRegistered: 'Adressen {email} är redan registrerad',
      existingAccountWithClub: ' (klubb: {clubName})',
      existingAccountQuestion:
        'Vill du verifiera kontot igen och få en ny magic link?',
      confirmAccount: 'Ja, verifiera kontot',
      useDifferentEmail: 'Använd en annan adress',
      checkEmailRelogin: 'Kontrollera din e-post! Ange koden för att få en ny magic link.',
      checkEmailCode: 'Kontrollera din e-post! Ange den 6-siffriga verifieringskoden.',
      resendCode: 'Skicka kod igen',
      cancel: 'Avbryt',
      devCodeHint: 'Utvecklingskod: {code}',
      magicLinkSent: 'Magic link skickad till din e-post. Öppna länken för att logga in.',
      magicLinkFailed:
        'Verifieringen lyckades, men magic link kunde inte skickas. Försök igen om en stund.',
      backToStart: 'Tillbaka till start',
      invalidCode: 'Ange en 6-siffrig verifieringskod',
      verificationFailed: 'Verifieringen misslyckades',
      codeSendFailed: 'Det gick inte att skicka koden.',
      codeResendFailed: 'Det gick inte att skicka koden igen.',
      footerBrand: 'Board Game League',
      footerCompany: 'Proseduuri Oy',
      languageLabel: 'Språk'
    },
    onboarding: {
      welcome: 'Välkommen!',
      welcomeSubtitle: 'Låt oss skapa din egen brädspelsklubb',
      stepClub: 'Klubbinformation',
      stepAdmin: 'Adminkonto',
      stepSettings: 'Inställningar',
      clubCreated: 'Klubben skapad',
      welcomeEmailFailed:
        'Din klubb är klar, men välkomstmeddelandet kunde inte skickas. Be en admin om en magic link eller försök igen.',
      welcomeEmailSent:
        'Din klubb är klar. Kontrollera din e-post — vi skickade en magic link för inloggning.',
      backToHome: 'Tillbaka till startsidan',
      clubDetailsTitle: 'Klubbinformation',
      clubDetailsDescription: 'Berätta om din brädspelsklubb',
      clubNameLabel: 'Klubbnamn *',
      clubNamePlaceholder: 't.ex. Göteborgs Tärningsgäng',
      clubSlugLabel: 'URL-adress *',
      clubSlugPlaceholder: 'goteborgs-tarningsgang',
      clubDescriptionLabel: 'Beskrivning (valfritt)',
      clubDescriptionPlaceholder: 'En kort beskrivning av er klubb...',
      adminTitle: 'Ditt adminkonto',
      adminDescription: 'Du blir klubbens första admin',
      adminNameLabel: 'Ditt namn *',
      adminNamePlaceholder: 'Hur känner andra spelare igen dig?',
      emailLabel: 'E-post',
      magicLinkInfo: 'Du loggar alltid in med en magic link. Inga lösenord att komma ihåg!',
      settingsTitle: 'Grundinställningar',
      settingsDescription: 'Du kan ändra dessa senare i inställningarna',
      languageLabel: 'Språk',
      timezoneLabel: 'Tidszon',
      timezoneHelsinki: 'Helsingfors (UTC+2/+3)',
      timezoneStockholm: 'Stockholm (UTC+1/+2)',
      timezoneLondon: 'London (UTC+0/+1)',
      summaryTitle: 'Sammanfattning',
      summaryClub: 'Klubb:',
      summaryUrl: 'URL:',
      summaryAdmin: 'Admin:',
      errorClubName: 'Ange ett klubbnamn',
      errorClubSlug: 'Ange en URL för klubben',
      errorAdminName: 'Ange ditt namn',
      back: 'Tillbaka',
      next: 'Nästa',
      createClub: 'Skapa klubb',
      languageFi: 'Suomi',
      languageEn: 'English',
      languageSv: 'Svenska'
    }
  }
};

/** Replace {key} placeholders in translation strings */
export function formatMessage(template, vars = {}) {
  if (!template) return '';
  return String(template).replace(/\{(\w+)\}/g, (_, key) =>
    vars[key] != null ? String(vars[key]) : `{${key}}`
  );
}

export default appTranslations;
